import { env } from '@utils/env.ts'
import { b, type HTMLItemOptions } from '@utils/build.ts'
import type { AppType } from '#/env'

export interface MenuElement {
  href: string
  label?: string
  target: AppType
  text: string
}

export const getTargets = (target: AppType, isProd: boolean): string => {
  const targets: Record<AppType, string> = {
    core: env('VITE_CORE_URL', isProd),
    auth: env('VITE_AUTH_URL', isProd),
    dashboard: env('VITE_DASHBOARD_URL', isProd),
    admin: env('VITE_ADMIN_URL', isProd),
  }
  return targets[target]
}

export const getMenuListItems = (document: Document, items: HTMLItemOptions[]): HTMLLIElement[] => {
  return items.map((options) => {
    return b('li', document, {
      children: [b('a', document, { ...options, attrs: { ...options.attrs!, class: 'neon-text-primary' } })],
    })
  })
}
